import React, { useEffect, useState } from "react";

function fmtMoney(amount, currency = "CAD") {
  const n = Number(amount);
  if (!Number.isFinite(n)) return `${amount ?? "—"} ${currency}`;
  return `${n.toFixed(2)} ${currency}`;
}

export default function AdminApproveModal({ open, tx, onClose, onConfirm }) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) {
      setLoading(false);
      return;
    }
    setLoading(false);
  }, [open, tx?.reference]);

  if (!open || !tx) return null;

  async function confirm() {
    if (loading) return;
    setLoading(true);
    try {
      await onConfirm?.();
      onClose?.();
    } finally {
      setLoading(false);
    }
  }

  const currency = (tx.currency || "CAD").toUpperCase();
  const amountLine = fmtMoney(tx.amount, currency);

  return (
    <div
      className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Approuver la transaction"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className="w-full max-w-lg rounded-2xl bg-white dark:bg-slate-900 shadow-xl border border-black/10 dark:border-white/10 overflow-hidden">
        <div className="p-5 border-b border-black/10 dark:border-white/10">
          <h3 className="text-base font-semibold text-slate-900 dark:text-white">
            Approuver la transaction
          </h3>
          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
            Ref: <b>{tx.reference || "—"}</b>
          </p>
        </div>

        <div className="p-5 space-y-3 text-sm text-slate-700 dark:text-slate-200">
          <div className="rounded-2xl border border-black/10 dark:border-white/10 bg-slate-50 dark:bg-white/5 p-4 space-y-1">
            <div>
              Type: <b>{tx.type || "—"}</b>
            </div>

            <div>
              Montant (ledger): <b>{amountLine}</b>
            </div>

            {/* CAD-only note */}
            <div className="text-xs text-slate-500 dark:text-slate-400 pt-2">
              ✅ Mode CAD-only : <b>tx.amount</b> représente directement le montant ledger (CAD). Aucune conversion/convertedAmount n’est utilisée.
            </div>
          </div>

          <div className="text-xs text-slate-500 dark:text-slate-400">
            ⚠️ L’approbation finalise l’écriture ledger et met à jour le solde selon la logique serveur.
          </div>
        </div>

        <div className="p-5 border-t border-black/10 dark:border-white/10 flex gap-2">
          <button
            type="button"
            onClick={() => onClose?.()}
            className="flex-1 rounded-2xl border border-black/10 dark:border-white/10 bg-white dark:bg-slate-900 py-3 text-sm font-medium
                       text-slate-900 dark:text-white hover:bg-black/5 dark:hover:bg-white/10 transition"
          >
            Annuler
          </button>

          <button
            type="button"
            disabled={loading}
            onClick={confirm}
            className="flex-1 rounded-2xl bg-slate-900 text-white py-3 text-sm font-medium hover:opacity-95 transition disabled:opacity-60 dark:bg-white dark:text-slate-900"
          >
            {loading ? "Validation..." : "Approuver"}
          </button>
        </div>
      </div>
    </div>
  );
}
